import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { familia } from 'src/app/shared/object/familia.model';
import { formato } from 'src/app/shared/object/formato.model';
import { impuesto } from 'src/app/shared/object/impuesto.model';
import { lista_precio_detalle } from 'src/app/shared/object/lista_precio_detalle.model';
import { producto } from 'src/app/shared/object/producto.model';
import { producto_formatoJoin } from 'src/app/shared/object/producto_formatoJoin.model';
import { producto_impuesto } from 'src/app/shared/object/producto_impuesto.model';
import { producto_impuestoJoin } from 'src/app/shared/object/producto_impuestoJoin.model';
import { rubro } from 'src/app/shared/object/rubro.model';
import { unidad_medida } from 'src/app/shared/object/unidad_medida.model';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { ToastService } from 'ng-uikit-pro-standard';
import { ConsoleService } from "src/app/shared/services/console.service";

@Component({
  selector: 'app-producto-modal-seleccionar-impuesto',
  templateUrl: './modal-seleccionar-impuesto.component.html',
  styleUrls: ['../productos.component.scss'],
  providers: [SecurityService, ValidadoresService]
})
export class ProductoModalSeleccionarImpuestoComponent implements OnInit {

  @Output() onImpuestoSeleccionado: EventEmitter<number> = new EventEmitter<number>()

  private client: GraphQLClient = null;
  listaImpuesto: impuesto[];
  codigo_impuesto: number = 0

  // Modales
  @ViewChild('seleccionImpuesto', { static: true }) seleccionImpuestoModal: ModalDirective;

  // Utils
  private log: any
  mode: 'SELECT' | 'VIEW';
  public rut_empresa: number;

  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
  ) {
    this.client = client;
    this.log = this.clog.log('SELLECCION-IMPUESTO')
  }

  ngOnInit() {
    this.rut_empresa = Number(this.accesolocalstorage.getRutEmpresa());
  }

  loadAndShow(codigo_impuesto: number) {
    this.mode = 'SELECT'
    this.codigo_impuesto = codigo_impuesto
    this.handleObtenerImpuestos()
  }

  loadAndShowOnlyView(codigo_impuesto: number) {
    this.mode = 'VIEW'
    this.codigo_impuesto = codigo_impuesto
    this.handleObtenerImpuestos()
  }

  handleObtenerImpuestos() {
    this.obtenerImpuestosProductos(({ registros }) => {
      this.listaImpuesto = registros;
      this.seleccionImpuestoModal.show()
    })
  }

  obtenerImpuestosProductos(callback: Function) {
    let self = this;
    this.client.query({
      query: gql`
      {
        impuesto {
          obtenerImpuestosAdicProductos {
            respuesta {
              registros {
                codigo
                nombre
                descripcion
                es_adicional
                es_retenido
                es_porcentaje
                valor
                factor
                fecha_registro
              }
            }
          }
        }
      }
      `,
      // variables: {
      //   "empresa_rut": this.rut_empresa
      // },
      fetchPolicy: 'network-only',
    }, function (respuesta) {
      callback(respuesta.data.impuesto.obtenerImpuestosAdicProductos.respuesta)
    });
  }


  capturaImpuesto(impuesto: number) {
    this.codigo_impuesto = impuesto
    this.log('inputParams', JSON.stringify(this.codigo_impuesto))

    this.onImpuestoSeleccionado.emit(impuesto);
  }

  capturaImpuestoCero() {
    this.codigo_impuesto = 0
    this.log('inputParams', JSON.stringify(this.codigo_impuesto))

    this.onImpuestoSeleccionado.emit(0);
  }
}
